
<!-- summary actions -->
<ng-container *ngIf="summary">
  <!-- remove this later, for MAYBANK DEMO -->
  <div *ngIf="summary.SystemSummaryName == 'AddToSpendDataRequestFilter'" class="SDIR" style="position: relative">
    <span class="help-icon" title="Info" style="position: absolute;left: 3px;top: -1px;">
      <img class="help-icon-img" src="../../assets/images/i-ic-blue.png" style="width: 14px;height: 14px;">
    </span>
    <p style="margin-left: 23px;font-size: 16px;font-weight: bold;">Hi, I'm your Virtual Procurement Assistant. What are you looking for?</p>
  </div>
  <!-- MAYBANK DEMO -->
  <div [hidden]="collapsed" class="table-action-container" [class.fixHeight]="!showSummaryMenu && groupFormat.split(':')[0].toUpperCase() != 'HEADER'">
    <div *ngIf="showSummaryMenu" class="summary-settings" (click)="onContextMenu($event, actions)">
      <mat-icon>menu</mat-icon>
    </div>
    <div *ngIf="(summary.Actions.length > 0 || rowsToUpdate.length > 0) && (summaryLayout == 'TABLE' || summaryLayout == 'HIERARCHY' || summaryLayout == 'HIERARCHYVIEW' || summaryLayout == 'CARDINPUT')" 
      class="summary-table-action" [class.pr]="showSummaryMenu" [class.no-title]="!documentName">
      <a *ngIf="rowsToUpdate.length > 0" href="javascript:void(0)" class="link-button-action" (click)="saveAllChanges()">
        <span class="action-group-ic" style="margin-right: 5px;font-size: 14px;">
          <fa name="floppy-o" class="floppy-o"></fa>
        </span>{{ actionSaveDisplay ? actionSaveDisplay : 'Save changes' }}
      </a>
      <ng-container *ngFor="let action of summary.Actions">
        <a *ngIf="!action.IsHidden" href="javascript:void(0)" class="link-button-action" (click)="performAction('', action.ActionCommand, action)" [class.disabled]="action.IsDisabled">
          <ng-container *ngIf="action.ActionDisplay.split('|').length > 1;else text" >
            <span class="action-group-ic">
              <ng-container [ngSwitch]="action.ActionDisplay.split('|')[0]">
                <ng-container *ngSwitchCase = "'Add'">
                  <fa name="plus-circle" class="plus-circle"></fa>
                </ng-container>
                <ng-container *ngSwitchCase = "'Clear'">
                  <fa name="minus-circle" class="minus-circle"></fa>
                </ng-container>
                <ng-container *ngSwitchCase = "'Help'">
                  <fa name="question-circle" class="question-circle"></fa>
                </ng-container>
                <ng-container *ngSwitchCase = "'Delete'">
                  <fa name="trash" class="trash"></fa>
                </ng-container>
                <img *ngSwitchCase = "'In'" class="in" src='../../assets/images/import-ic.png'>
                <img *ngSwitchCase = "'Out'" class="in" src='../../assets/images/export-ic.png'>
              </ng-container>
            </span>
            {{ action.ActionDisplay.split('|')[1] }}
          </ng-container>
          <ng-template #text>
              {{ action.ActionDisplay }}
          </ng-template>
        </a>
      </ng-container>
    </div>
  </div>
  <div *ngIf="showSummaryMenu || ((summary.Actions.length > 0 || rowsToUpdate.length > 0) && (summaryLayout == 'TABLE' || summaryLayout == 'HIERARCHY' || summaryLayout == 'HIERARCHYVIEW' || summaryLayout == 'CARDINPUT'))" class="clearfix"></div>
</ng-container>

<!-- page loading -->
<ng-container *ngIf="isBusy || isCardBusy">
  <div [ngClass]="{'container-loader': fixLoader && isSubSummary ? false : true, 'container-preload gradient': fixLoader && isSubSummary}">
    <ngx-loading [show]="isBusy && !fixLoader" [config]="loaderConfig"></ngx-loading>
    <ngx-loading [show]="isCardBusy && !fixLoader" [config]="loaderConfig"></ngx-loading>
  </div>
</ng-container>

<div *ngIf="summary" [ngClass]="{'summary-container': true, 'min': isBusy, 'space': visibleSummaryActions.length > 0 && !isSummaryPopup, 'unfill': filledSpace == 0, 'in-popup': isSummaryPopup }">
  <div class="document-debug" style="display:none">
      SummaryId: {{summary.SummaryId}}
      SummaryTypeCode: {{summary.TypeCode}}
      SummaryName: {{summary.SummaryName}}
      SystemSummaryName: {{summary.SystemSummaryName}}
      SummaryTypeCode: {{summary.TypeCode}}
  </div>
  <p *ngIf="summary.HeaderText && !isSummaryPopup && summaryLayout != 'CARDIMAGE'" class="summary-header-text {{summaryLayout}}" [innerHTML]="summary.HeaderText"></p>
  <div #subsummary 
  [ngClass]="{'custom-scrollbar sub-summary-container': true, 'collapsed':collapsed, 'has-header': summary.HeaderText, 'has-footer': summary.FooterText, 'no-actions': visibleSummaryActions.length == 0,
  'card-image-layout': summaryLayout == 'CARDIMAGE', 'table-layout': summaryLayout == 'TABLE' }"
  infinite-scroll
  [infiniteScrollDistance]="'0'"
  [infiniteScrollThrottle]="'50'"
  [immediateCheck]="true"
  [scrollWindow]="false"
  (scrolled)="onScrolled($event)"
  [@openClose]="isBusy && animate ? 'closed' : 'open'">
    <ng-container *ngIf="summary.TotalRows > 0;else summaryNoData">
      <div *ngIf="summaryLayout == 'CARDDETAIL'">
        <virtual-scroller #scroll [items]="summaryData" [parentScroll]="subsummary" (vsUpdate)="viewPortItems = $event" (vsChange)="fetchMore($event)" class="card-scroller">
          <div *ngFor="let summaryCard of scroll.viewPortItems;index as i" 
          id="cardDetail_{{i}}"
          [ngClass]="{'horizontalCard' : true, 'cardWhite' : true, 'border-cs' : summaryCard[idColumn] == selectedItemId}" 
          (click)="selectItem(summaryCard[idColumn], true);">
            <div class="leftIndicatorPanel" [ngStyle]="{'background-color' : getIndicatorColor(summaryCard[retrieveDataByCardProperty('id1')])}"></div>
            <div *ngIf="summary.ShowCheckmark" class="check-container" (click)="checkmark($event, summaryCard)">
              <div [ngClass]="{'circle-loader': true, 'load-complete': markList.indexOf(summaryCard[idColumn]) > -1}">
                <div class="checkmark-1 draw" [ngStyle]="{'display': markList.indexOf(summaryCard[idColumn]) > -1 ? 'block' : 'none'}"></div>
              </div>
            </div>
            <div class="card-detail-content">
              <div class="card-detail-content-1">
                <p *ngIf="summaryCard[retrieveDataByCardProperty('prop1')]" class="cardMiniSubtitle fw-600" [title]="summaryCard[retrieveDataByCardProperty('prop1')]">{{summaryCard[retrieveDataByCardProperty('prop1')]}}</p>
                <p *ngIf="summaryCard[retrieveDataByCardProperty('prop2')]" class="cardMiniSubtitle" [title]="summaryCard[retrieveDataByCardProperty('prop2')]">{{summaryCard[retrieveDataByCardProperty('prop2')]}}</p>
                <p *ngIf="summaryCard[retrieveDataByCardProperty('prop5')]" class="cardMiniSubtitle" [title]="summaryCard[retrieveDataByCardProperty('prop5')]">{{summaryCard[retrieveDataByCardProperty('prop5')]}}</p>
              </div>
              <div class="card-detail-content-2">
                <p class="cardProp cardValue" [title]="summaryCard[retrieveDataByCardProperty('prop3')]">{{summaryCard[retrieveDataByCardProperty('prop3')]}}</p>
                <p class="cardValue prime">{{summaryCard[retrieveDataByCardProperty('prop4')]}}</p>
                <p class="cardValue prime">{{summaryCard[retrieveDataByCardProperty('prop6')]}}</p>
              </div>
            </div>
          </div>
        <div *ngIf="isFetching" class="loader-fetch">Loading...</div>
      </virtual-scroller>
      </div>
      <div *ngIf="summaryLayout == 'CARDDETAILTITLE'">
        <virtual-scroller #scroll [items]="summaryData" [parentScroll]="subsummary" (vsUpdate)="viewPortItems = $event" (vsChange)="fetchMore($event)" class="card-scroller">
          <div *ngFor="let summaryCard of scroll.viewPortItems;index as i" 
          id="cardDetail_{{i}}"
          [ngClass]="{'card-title': true, 'border-cs' : summaryCard[idColumn] == selectedItemId}" 
          (click)="selectItem(summaryCard[idColumn], true);">
            <div class="sub-content" 
            [ngStyle]="{'border-left' : '4px solid ' + getIndicatorColor(summaryCard[retrieveDataByCardProperty('id1')])}">
              <div *ngIf="summary.ShowCheckmark" class="check-container" (click)="checkmark($event, summaryCard)">
                <div [ngClass]="{'circle-loader': true, 'load-complete': markList.indexOf(summaryCard[idColumn]) > -1}">
                  <div class="checkmark-1 draw" [ngStyle]="{'display': markList.indexOf(summaryCard[idColumn]) > -1 ? 'block' : 'none'}"></div>
                </div>
              </div>
              <div class="card-title-content">
                <p class="cd-title" *ngIf="summaryCard[retrieveDataByCardProperty('prop1')]"
                  [title]="summaryCard[retrieveDataByCardProperty('prop1')]">{{summaryCard[retrieveDataByCardProperty('prop1')]}}</p>
                <div class="card-title-content-1">
                  <p><span *ngIf="summaryCard[retrieveDataByCardProperty('prop2')]"
                    [title]="summaryCard[retrieveDataByCardProperty('prop2')]">
                      {{summaryCard[retrieveDataByCardProperty('prop2')]}}
                    </span></p>
                  <p><span *ngIf="summaryCard[retrieveDataByCardProperty('prop3')]"
                    [title]="summaryCard[retrieveDataByCardProperty('prop3')]">
                      {{summaryCard[retrieveDataByCardProperty('prop3')]}}
                    </span></p>
                </div>
                <div class="card-title-content-2">
                  <p><span *ngIf="summaryCard[retrieveDataByCardProperty('prop4')]"
                    [title]="summaryCard[retrieveDataByCardProperty('prop4')]">
                      {{summaryCard[retrieveDataByCardProperty('prop4')]}}
                    </span></p>
                  <p><span *ngIf="summaryCard[retrieveDataByCardProperty('prop5')]"
                    [title]="summaryCard[retrieveDataByCardProperty('prop5')]">
                      {{summaryCard[retrieveDataByCardProperty('prop5')]}}
                    </span></p>
                </div>
              </div>
            </div>
          </div>
        <div *ngIf="isFetching" class="loader-fetch">Loading...</div>
      </virtual-scroller>
      </div>
      <div *ngIf="summaryLayout== 'CHATCARD'" class="chat-card-container">
        <!-- new layout chat card -->
        <div class="chat-flex-group" *ngIf="!isPreview">
          <input #textbox type="text"
          [ngClass]="{'form-control': true}"
          placeholder="Add a comment...">
          <button class="btn btn-primary chat-btn" (click)="addNewRemarkForDocument(textbox)">
            Add
          </button>
        </div>

        <div class="chat-card">
          <div class="chat-card-content" *ngFor="let summaryCard of summaryData" id="chatCard_{{i}}">
            <div *ngIf="summaryCard[retrieveDataByCardProperty('prop2')]" class="chat-card-item-2" [title]="summaryCard[retrieveDataByCardProperty('prop2')]">
              {{summaryCard[retrieveDataByCardProperty('prop2')]}}
              <span *ngIf="summaryCard[retrieveDataByCardProperty('prop1')]" class="chat-card-item-1" [title]="summaryCard[retrieveDataByCardProperty('prop1')]">{{summaryCard[retrieveDataByCardProperty('prop1')]}}</span>
            </div>
            
            <p *ngIf="summaryCard[retrieveDataByCardProperty('prop3')]" class="chat-card-item-3" [title]="summaryCard[retrieveDataByCardProperty('prop3')]">{{summaryCard[retrieveDataByCardProperty('prop3')]}}</p>
          </div>
        </div>
      </div>
      <div *ngIf="summaryLayout == 'CARDSTANDARDSTATUS'">
        <div *ngFor="let summaryCard of summaryData;let i = index" 
        id="cardStandardStatus_{{i}}"
        class="horizontalCard card-basic-grey" (click)="selectItem(summaryCard[idColumn], true);">
          <div class="leftIndicatorPanel" [ngStyle]="{'background-color' : getIndicatorColor(summaryCard[retrieveDataByCardProperty('id1')])}"></div>
          <div class="col-12" style="padding: 0px 20px 0 15px;">
            <p class="card-basic-desc">{{summaryCard[retrieveDataByCardProperty('prop1')]}}</p>
            <p class="card-basic-title" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop2')]"></p>
            <p class="card-basic-sub-title">{{summaryCard[retrieveDataByCardProperty('prop3')]}}</p>
          </div>
        </div>
      </div>
      <div *ngIf="summaryLayout == 'CARDBASIC'">
        <div *ngFor="let summaryCard of summaryData;let i = index" 
        id="cardBasic_{{i}}"
        class="horizontalCard card-basic-grey stack-{{getStack(summaryCard[retrieveDataByCardProperty('ID')])}}" (click)="selectItem(summaryCard[idColumn], true);">
          <div class="leftIndicatorPanel" [ngStyle]="{'background-color' : getIndicatorColor(summaryCard[retrieveDataByCardProperty('id1')])}"></div>
          <div class="col-12" style="padding: 0px 20px 0 15px;"><p></p>
            <p class="card-basic-desc">{{summaryCard[retrieveDataByCardProperty('prop1')]}}</p>
            <p class="card-basic-title" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop2')]"></p>
            <p class="card-basic-sub-title">{{summaryCard[retrieveDataByCardProperty('prop3')]}}</p>
          </div>
          <span [ngClass]="{'toggle-card': getMulti(summaryCard[retrieveDataByCardProperty('ID')]), 'flip': getShowCards(summaryCard[retrieveDataByCardProperty('ID')])}" 
          (click)="toggleStack(summaryCard[retrieveDataByCardProperty('grp')], $event)"
          [title]="getShowCards(summaryCard[retrieveDataByCardProperty('ID')]) ? 'Show Less' : 'Show More'"></span>
          <span *ngIf="getMulti(summaryCard[retrieveDataByCardProperty('ID')])" class="stack-count">
            {{ getShowCards(summaryCard[retrieveDataByCardProperty('ID')]) ? 'Show Less' : getStackItemsCount(summaryCard[retrieveDataByCardProperty('grp')]) }}
          </span>
        </div>
      </div>
      <div *ngIf="summaryLayout == 'CARDINPUT'">
        <virtual-scroller #scroll [items]="summaryData" [parentScroll]="subsummary" (vsUpdate)="viewPortItems = $event" (vsChange)="fetchMore($event)" class="card-scroller card-input-scroller">
          <div class="line-separator"></div>
          <div *ngFor="let summaryCard of scroll.viewPortItems;let i = index" class="card-input-container container-{{i}}">
            <div id="cardInput_{{i}}" class="card-input">
              <p class="card-input-item" *ngIf="summaryCard[retrieveDataByCardProperty('prop1')]">{{summaryCard[retrieveDataByCardProperty('prop1')]}}</p>
              <p class="card-input-item" *ngIf="summaryCard[retrieveDataByCardProperty('prop2')]" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop2')]"></p>
              <p class="card-input-item" *ngIf="summaryCard[retrieveDataByCardProperty('prop3')]">{{summaryCard[retrieveDataByCardProperty('prop3')]}}</p>
              <p class="card-input-item" *ngIf="summaryCard[retrieveDataByCardProperty('prop4')]">{{summaryCard[retrieveDataByCardProperty('prop4')]}}</p>
              <div *ngIf="retrieveDataByCardProperty('prop5')" style="font-size: 16px;background-color: #fff;flex: 1;">
                <ng-container *ngIf="retrieveColumnTypeByCardProperty('prop5') == 'EDITABLETEXT'">
                  <input #editabletext type="text" [(ngModel)]="summaryCard[retrieveDataByCardProperty('prop5')]"  class="editable-text"
                    (input)="onCardChangeData(summaryCard[idColumn], 'prop5', editabletext.value)"
                    (change)="formatData(summaryCard, 'prop5', editabletext)" [name]="summaryCard[idColumn]" />
                </ng-container>
                <ng-container *ngIf="retrieveColumnTypeByCardProperty('prop5') == 'EDITABLESTEP'">
                  <mat-form-field appearance="outline" class="summary-input" [class.mat-form-field-invalid]="summaryCard['error']">
                    <div matPrefix *ngIf="summaryCard[retrieveDataByCardProperty('button1')]" class="input-ic-container" 
                      (click)="calculate(summaryCard, 'prop5', editablestep.value, 'button1')" title="Decrement" aria-label="Decrement the value"
                        matRipple
                        [matRippleCentered]="true"
                        [matRippleUnbounded]="true"
                        [matRippleRadius]="10">
                      <fa name="minus"></fa>
                    </div>
                    <input #editablestep type="text" matInput placeholder="Enter amount"
                      [(ngModel)]="summaryCard[retrieveDataByCardProperty('prop5')]"
                      (input)="onCardChangeData(summaryCard[idColumn], 'prop5', editablestep.value)"
                      (change)="formatData(summaryCard, 'prop5', editablestep)"
                      [name]="summaryCard[idColumn]">
                      <div matSuffix *ngIf="summaryCard[retrieveDataByCardProperty('button2')]" class="input-ic-container" 
                        (click)="calculate(summaryCard, 'prop5', editablestep.value, 'button2')" title="Increment" aria-label="Increment the value"
                        matRipple
                        [matRippleCentered]="true"
                        [matRippleUnbounded]="true"
                        [matRippleRadius]="10">
                        <fa name="plus"></fa>
                      </div>
                  </mat-form-field>
                  <p *ngIf="summaryCard['error']" class="invalid-feedback" style="display: block;background-color: #f8f8f8;margin-top: 0;position: absolute;width: auto;">
                    Invalid format</p>
                </ng-container>
              </div>
            </div>
            <p *ngIf="summaryCard[retrieveDataByCardProperty('prop6')]" class="card-input-subtitle">{{summaryCard[retrieveDataByCardProperty('prop6')]}}</p>
          </div>
          <div *ngIf="isFetching" class="loader-fetch">Loading...</div>
        </virtual-scroller>
      </div>
      <div *ngIf="summaryLayout == 'CARDSTANDARD'">
        <virtual-scroller #scroll [items]="summaryData" [parentScroll]="subsummary" (vsUpdate)="viewPortItems = $event" (vsChange)="fetchMore($event)" class="card-scroller">
          <div *ngFor="let summaryCard of scroll.viewPortItems;index as i" 
          id="cardStandard_{{i}}"
          [ngClass]="{'horizontalCard' : true, 'card-standard' : true, 'border-cs' : summaryCard[idColumn] == selectedItemId}" 
          (click)="selectItem(summaryCard[idColumn], true);">
            <div class="leftIndicatorPanel" [ngStyle]="{'background-color' : getIndicatorColor(summaryCard[retrieveDataByCardProperty('id1')])}"></div>
            <div *ngIf="summary.ShowCheckmark" class="check-container col-1" (click)="checkmark($event, summaryCard)">
              <div [ngClass]="{'circle-loader': true, 'load-complete': markList.indexOf(summaryCard[idColumn]) > -1}">
                <div class="checkmark-1 draw" [ngStyle]="{'display': markList.indexOf(summaryCard[idColumn]) > -1 ? 'block' : 'none'}"></div>
              </div>
            </div>
            <div class="card-standard-content">
              <div [ngClass]="{'card-standard-container': true, 'has-checkmark': summary.ShowCheckmark}">
                <p class="card-standard-header line-clamp-1" *ngIf="summaryCard[retrieveDataByCardProperty('prop1')]" [title]="summaryCard[retrieveDataByCardProperty('prop1')]">{{summaryCard[retrieveDataByCardProperty('prop1')]}}</p>
                <p class="card-standard-title line-clamp-1" *ngIf="summaryCard[retrieveDataByCardProperty('prop2')]" [title]="summaryCard[retrieveDataByCardProperty('prop2')]">
                  {{summaryCard[retrieveDataByCardProperty('prop2')]}}
                </p>
              </div>
              <div [ngClass]="{'card-standard-container': true, 'has-checkmark': summary.ShowCheckmark}">
                <p class="card-standard-sub line-clamp-1" *ngIf="summaryCard[retrieveDataByCardProperty('prop3')]" [title]="summaryCard[retrieveDataByCardProperty('prop3')]">{{summaryCard[retrieveDataByCardProperty('prop3')]}}</p>
                <p class="card-standard-sub prime" *ngIf="summaryCard[retrieveDataByCardProperty('prop4')]">
                  {{summaryCard[retrieveDataByCardProperty('prop4')]}}
                </p>
              </div>
            </div>
          </div>
          <div *ngIf="isFetching" class="loader-fetch">Loading...</div>
        </virtual-scroller>
      </div>
      <div *ngIf="summaryLayout == 'CARDIMAGEBASIC'">
        <virtual-scroller #scroll [items]="summaryData" [parentScroll]="subsummary" (vsUpdate)="viewPortItems = $event" (vsChange)="fetchMore($event)" class="card-scroller">
          <div *ngFor="let summaryCard of scroll.viewPortItems;let i = index" class="card-image-basic">
            <div class="card-image-basic-group" [class.border-cs]="summaryCard[idColumn] == selectedItemId"
            id="cardImageBasic_{{i}}" (click)="selectItem(summaryCard[idColumn], true)">
              <div class="indicator-panel" [ngStyle]="{'background-color' : getIndicatorColor(summaryCard[retrieveDataByCardProperty('id1')])}"></div>
              <div class="card-image-basic-img" (click)="selectItem(summaryCard[idColumn], true);">
                <img [src]="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) ? getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) : '../../assets/images/no_image_available.jpeg'" alt="image">
              </div>
              <div class="card-image-basic-sub-group">
                <p class="card-image-basic-header" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop1')]"></p>
                <p class="card-image-basic-sub-header" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop2')]"></p>
                <p class="card-image-basic-sub-header" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop3')]"></p>
                <p class="card-image-basic-desc" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop4')]"></p>
              </div>
            </div>
          </div>
          <div *ngIf="isFetching" class="loader-fetch">Loading...</div>
        </virtual-scroller>
      </div>

      <div *ngIf="summaryLayout == 'CARDMESSAGES'" class="message-card">
        <div class="message-content" *ngFor="let summaryCard of summaryData" id="messageCard_{{i}}">
          <div class="system-message" *ngIf="summaryCard[retrieveDataByCardProperty('id1')] == 'System'">
            <div *ngIf="summaryCard[retrieveDataByCardProperty('prop1')]" class="message-header" [title]="summaryCard[retrieveDataByCardProperty('prop1')]">
              {{summaryCard[retrieveDataByCardProperty('prop1')]}}
            </div>
            <div [title]="summaryCard[retrieveDataByCardProperty('prop2')]" class="message-body">
              {{summaryCard[retrieveDataByCardProperty('prop2')]}}
            </div>
            <div *ngIf="summaryCard[retrieveDataByCardProperty('prop3')]" class="message-footer" [title]="summaryCard[retrieveDataByCardProperty('prop3')]">
              {{summaryCard[retrieveDataByCardProperty('prop3')]}}
            </div>
          </div>
          <div class="user-message" *ngIf="summaryCard[retrieveDataByCardProperty('id1')] == 'User'">
            <div *ngIf="summaryCard[retrieveDataByCardProperty('prop1')]" class="message-header" [title]="summaryCard[retrieveDataByCardProperty('prop1')]">
              {{summaryCard[retrieveDataByCardProperty('prop1')]}}
              </div>
              <div [title]="summaryCard[retrieveDataByCardProperty('prop2')]" class="message-body">
                {{summaryCard[retrieveDataByCardProperty('prop2')]}}
              </div>
              <div *ngIf="summaryCard[retrieveDataByCardProperty('prop3')]" class="message-footer" [title]="summaryCard[retrieveDataByCardProperty('prop3')]">
                {{summaryCard[retrieveDataByCardProperty('prop3')]}}
              </div>
          </div>
        </div>
        <div *ngIf="isFetching" class="loader-fetch">Loading...</div>
      </div>

      <div *ngIf="summaryLayout == 'CARDOPTION'" class="card-option-container">
        <div class="card-option-sub-container" *ngFor="let summaryCard of summaryData;let i = index">
          <div class="card-option" id="cardOption_{{i}}">
            <div class="card-option-img" (click)="selectItem(summaryCard[idColumn], true);">
              <img [src]="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) ? getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) : '../../assets/images/no_image_available.jpeg'" alt="image">
            </div>
            <div class="card-option-body">
              <p class="card-option-0" *ngIf="summaryCard[retrieveDataByCardProperty('id1')] == 1">✓ Best rate</p>
              <p class="card-option-1">{{summaryCard[retrieveDataByCardProperty('prop1')]}}</p>
              <p class="card-option-2" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop2')]"></p>
              <p class="card-option-3" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop3')]"></p>
              <p class="card-option-4" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop4')]"></p>
              <!-- <button class="btn btn-option" 
                (click)="actionOnCardWithoutParam(summaryCard[retrieveDataByCardProperty('ID')], summaryCard[retrieveDataByCardProperty('button1')])">
                {{summaryCard[retrieveDataByCardProperty('lbl1')]}}
              </button> -->
              <div class="next-button" [title]="summaryCard[retrieveDataByCardProperty('lbl1')]" (click)="actionOnCardWithoutParam(summaryCard[retrieveDataByCardProperty('ID')], summaryCard[retrieveDataByCardProperty('button1')])">
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="summaryLayout == 'CARDOPTIONWIDE'" class="card-option-container">
        <div class="card-optionwide-sub-container" *ngFor="let summaryCard of summaryData;let i = index">
          <div class="card-option" id="cardOption_{{i}}">
            <div class="card-option-img" (click)="selectItem(summaryCard[idColumn], true);">
              <img [src]="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) ? getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) : '../../assets/images/no_image_available.jpeg'" alt="image">
            </div>
            <div class="card-option-body">
              <p class="card-option-0" *ngIf="summaryCard[retrieveDataByCardProperty('id1')] == 1">✓ Best rate</p>
              <p class="card-option-1 wide">{{summaryCard[retrieveDataByCardProperty('prop1')]}}</p>
              <p class="card-option-2 wide" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop2')]"></p>
              <p class="card-option-3" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop3')]"></p>
              <p class="card-option-2 wide" [innerHTML]="summaryCard[retrieveDataByCardProperty('prop4')]"></p>
              <!-- <button class="btn btn-option" 
                (click)="actionOnCardWithoutParam(summaryCard[retrieveDataByCardProperty('ID')], summaryCard[retrieveDataByCardProperty('button1')])">
                {{summaryCard[retrieveDataByCardProperty('lbl1')]}}
              </button> -->
              <div *ngIf="summaryCard[retrieveDataByCardProperty('button1')]" class="next-button" 
              [title]="summaryCard[retrieveDataByCardProperty('lbl1')] ? summaryCard[retrieveDataByCardProperty('lbl1')] : 'Next'" 
              (click)="actionOnCardWithoutParam(summaryCard[retrieveDataByCardProperty('ID')], summaryCard[retrieveDataByCardProperty('button1')])">
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="summaryLayout == 'CARDIMAGE'" class="card-image-main-container container-fluid">
        <h5 style="text-align: left;padding: 5px 0px 15px;float: left;">{{summary.SummaryName}}
          <span *ngIf="summary.HeaderText && !isSummaryPopup" class="summary-header-text" [innerHTML]="summary.HeaderText"></span>
        </h5>
        <div class="card-image-page-info">
          <button type="button" 
            [disabled]="summary.CurrentPage == 1" 
            [ngClass]="{'slide-prev': true, 'slide-arrow' :true, 'disabled': summary.CurrentPage == 1}" 
            aria-label="Previous" 
            role="button" 
            style="display: block;" 
            (click)="prevSlidePage()">Previous</button>
            <span style="margin: 0 15px;">Page {{ summary.CurrentPage }} of {{ summary.AvailablePages }}</span>
            <!-- <span id="pageNumber">{{ summary.CurrentPage }}</span> of
            <span id="summaryAvailablePage" style="padding-right: 5px;">{{ summary.AvailablePages }}</span> -->
            <!-- <span> | </span>
            <span style="padding-left: 5px;"><a href="javascript:void(0)" class="view-all-btn all" (click)="viewAllSummary()">View {{ showAll ? 'All' : 'Less' }}</a></span> -->
            <ng-container *ngFor="let page of pageNumbers">
              <button type="button" 
                [ngClass]="{'slide-page': true, 'slide-arrow': true, 'disabled': summary.CurrentPage === page}" 
                (click)="goToPage(page)">
                {{ page }}
              </button>
            </ng-container>
          <button type="button" 
          [disabled]="summary.CurrentPage == summary.AvailablePages" 
          [ngClass]="{'slide-next': true, 'slide-arrow': true, 'disabled': summary.CurrentPage == summary.AvailablePages}" 
          aria-label="Next" 
          role="button" 
          style="display: block;" 
          (click)="nextSlidePage()">Next</button>   
        </div>
        <div class="clearfix"></div>
        <div class="card imageCard">
          
          <div class="row">
          <div class="card-image-item" id="cardImage_{{i}}" *ngFor="let summaryCard of summaryData; let i=index">
            <div class="sub-card-image-item">
              <div class="card-image-sub-container" (click)="viewProductDetail(summaryCard[retrieveDataByCardProperty('ID')])">
              <div #imgcontainer class="img-container">
                <ng-container *ngIf="summaryCard[retrieveDataByCardProperty('ID')]; else noImage">
                  <img *ngIf="isImageLoad" class="img-loading" src="../../assets/images/lazyload.gif">
                  <!-- <img *ngIf="!isImageLoad" [src]="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) ? getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) : '../../assets/images/no_image_available.jpeg'" 
                  class="img" alt="image" /> -->
                  <ng-container *ngIf="!isImageLoad">

                    <ng-container *ngIf="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]); else defaultImage">
                      <img #img [src]="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')])" 
                      class="img" alt="image" style="visibility: hidden"/>
                      <app-image-zoom  [img]="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')])" 
                        [zoom]="1" [lenSize]="40" [imgWidth]="img.offsetWidth" [imgHeight]="img.offsetHeight"
                        [divZoomed]="divZoomed" ></app-image-zoom>
                      <div #divZoomed class="img-zoom-result" [class.right]="i == 3 || i == 4 || i == 8 || i == 9"></div>
                    </ng-container>

                    <ng-template #defaultImage>
                      <img [src]="'../../assets/images/no_image_available.jpeg'" 
                      class="img" alt="image" />
                    </ng-template>
                  </ng-container>
                  


                </ng-container>
                <ng-template #noImage>
                    <img src="../../assets/images/no_image_available.jpeg" alt="image" />
                </ng-template>
              </div>
              <span class="cardTitle card-desc" [title]="summaryCard[retrieveDataByCardProperty('prop1')]">
                  {{summaryCard[retrieveDataByCardProperty('prop1')]}}
              </span>
            </div>
              <p class="cardTitle line-clamp-1" [title]="summaryCard[retrieveDataByCardProperty('prop2')]">
                  {{summaryCard[retrieveDataByCardProperty('prop2')]}}
              </p>
              <div class="priceTitle" [title]="summaryCard[retrieveDataByCardProperty('prop3')]">{{summaryCard[retrieveDataByCardProperty('prop3')]}}
                <span style="font-size:15px;" [title]="summaryCard[retrieveDataByCardProperty('prop4')]">{{summaryCard[retrieveDataByCardProperty('prop4')]}}</span>
                <div class="clearfix"></div>
              </div>
              <div class="cardBodySubtitle">
                <a href="javascript:void(0)" [ngClass]="{'img-favourite': true, 'mb-highlight' : getBoolean(summaryCard[retrieveDataByCardProperty('id1')]) }"
                (click)="actionOnCardWithoutParam(summaryCard[retrieveDataByCardProperty('ID')], summaryCard[retrieveDataByCardProperty('button2')])"></a>
                <span style="float:left;margin-top:-1px;">Favourite</span>
                <div class="clearfix"></div>
              </div>
              <div class="flex-group">
                <div class="qty-container">
                  <div class="qty-icon" (click)="qtyInput.stepDown();$event.stopPropagation();$event.preventDefault()"><mat-icon>remove</mat-icon></div>
                  <input #qtyInput type="number" class="card-image-qty qty-min" min="1" value="1" (keyup)="keyupNumber(qtyInput, 100)">
                  <div class="qty-icon" (click)="qtyInput.stepUp();$event.stopPropagation();$event.preventDefault()"><mat-icon>add</mat-icon></div>
                </div>
                <button class="cart-btn btn btn-primary" 
                  (click)="actionOnCard(qtyInput.value, summaryCard[retrieveDataByCardProperty('ID')], summaryCard[retrieveDataByCardProperty('button1')], summaryCard[retrieveDataByCardProperty('data')],summary.CurrentPage);$event.stopPropagation();$event.preventDefault()">
                  Add to Cart
                </button>
              </div>
              <div style="clear:both"></div>
              <p class="subtitle line-clamp-1" *ngIf="summaryCard[retrieveDataByCardProperty('prop5')]">Last ordered on {{ summaryCard[retrieveDataByCardProperty('prop5')] | date:'dd MMM yyyy' }}</p>
              <p class="subtitle line-clamp-1" *ngIf="!summaryCard[retrieveDataByCardProperty('prop5')]">No one has ordered this item</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="summaryLayout == 'CARDIMAGEWIDE'" class="card-image-main-container container-fluid">
        <h5 style="text-align: left;padding: 5px 0px 15px;float: left;">{{summary.SummaryName}}
          <span *ngIf="summary.HeaderText && !isSummaryPopup" class="summary-header-text" [innerHTML]="summary.HeaderText"></span>
        </h5>
        <!-- <div class="card-image-page-info">
          <button type="button" 
            [disabled]="summary.CurrentPage == 1" 
            [ngClass]="{'slide-prev': true, 'slide-arrow' :true, 'disabled': summary.CurrentPage == 1}" 
            aria-label="Previous" 
            role="button" 
            style="display: block;" 
            (click)="prevSlidePage()">Previous</button>
            <span style="margin: 0 15px;">Page {{ summary.CurrentPage }} of {{ summary.AvailablePages }}</span>
            <!-- <span id="pageNumber">{{ summary.CurrentPage }}</span> of
            <span id="summaryAvailablePage" style="padding-right: 5px;">{{ summary.AvailablePages }}</span> -->
            <!-- <span> | </span>
            <span style="padding-left: 5px;"><a href="javascript:void(0)" class="view-all-btn all" (click)="viewAllSummary()">View {{ showAll ? 'All' : 'Less' }}</a></span>
          <button type="button" 
          [disabled]="summary.CurrentPage == summary.AvailablePages" 
          [ngClass]="{'slide-next': true, 'slide-arrow': true, 'disabled': summary.CurrentPage == summary.AvailablePages}" 
          aria-label="Next" 
          role="button" 
          style="display: block;" 
          (click)="nextSlidePage()">Next</button>   
        </div>
        <div class="clearfix"></div> -->
        <div class="card imageCard">
          
          <div class="row">
          <div class="card-image-wide-item" id="cardImage_{{i}}" *ngFor="let summaryCard of summaryData; let i=index">
            <div class="sub-card-image-item">
              <div class="card-image-sub-container">
              <div #imgcontainer class="img-container">
                <ng-container *ngIf="summaryCard[retrieveDataByCardProperty('ID')]; else noImage">
                  <img *ngIf="isImageLoad" class="img-loading" src="../../assets/images/lazyload.gif">
                  <!-- <img *ngIf="!isImageLoad" [src]="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) ? getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) : '../../assets/images/no_image_available.jpeg'" 
                  class="img" alt="image" /> -->
                  <ng-container *ngIf="!isImageLoad">

                    <ng-container *ngIf="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]); else defaultImage">
                      <img #img [src]="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')])" 
                      class="img" alt="image" />
                      <!-- <app-image-zoom  [img]="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')])" 
                        [zoom]="1" [lenSize]="40" [imgWidth]="img.offsetWidth" [imgHeight]="img.offsetHeight"
                        [divZoomed]="divZoomed" ></app-image-zoom>
                      <div #divZoomed class="img-zoom-result" [class.right]="i == 3 || i == 4 || i == 8 || i == 9"></div> -->
                    </ng-container>

                    <ng-template #defaultImage>
                      <img [src]="'../../assets/images/no_image_available.jpeg'" 
                      class="img" alt="image" />
                    </ng-template>
                  </ng-container>
                  


                </ng-container>
                <ng-template #noImage>
                    <img src="../../assets/images/no_image_available.jpeg" alt="image" />
                </ng-template>
              </div>
            </div>
              <p class="card-wide-title line-clamp-2" [title]="summaryCard[retrieveDataByCardProperty('prop1')]">
                  {{summaryCard[retrieveDataByCardProperty('prop1')] ? summaryCard[retrieveDataByCardProperty('prop1')] : 'No bid number'}}
              </p>
              <div class="card-wide-subtitle" [title]="summaryCard[retrieveDataByCardProperty('pro2')]">{{summaryCard[retrieveDataByCardProperty('prop2')]}}</div>
              <div class="card-wide-desc">{{summaryCard[retrieveDataByCardProperty('lbl3')]}} {{summaryCard[retrieveDataByCardProperty('prop3')]}}</div>
              <div class="flex-group">
                <button class="cart-btn btn btn-primary" 
                  (click)="selectItem(summaryCard[idColumn], true, true)">
                  Enter Bid Room
                </button>
              </div>
              </div>
            </div>
            <div class="card-image-wide-item loading-card-wide" *ngIf="isFetching">
              <div class="sub-card-image-item">
                <div class="card-image-sub-container gradient">
                  
                </div>
                <div class="load-text text-w-1 gradient"></div>
                <div class="load-text text-w-2 gradient"></div>
                <div class="load-text text-w-3 gradient"></div>
                <div class="text-w-4 gradient"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="summaryLayout == 'CARDIMAGEDETAIL'" class="card-image-main-container container">
        <ng-container *ngFor="let summaryCard of summaryData; let i=index">
          <div class="mb-img-container" id="cardImageDetail_{{i}}">
            <div class="mb-image-list" [class.single]="imageId.length < 4">
              <div #swiper class="swiper-container" [swiper]="swiperConfig" [(index)]="swiperIndex" (indexChange)="indexChange($event)">
                <div class="swiper-wrapper">
                  <ul *ngFor="let image of getCardImage(summaryCard[retrieveDataByCardProperty('ID')]); index as g" class="swiper-slide" (click)="setCurrentImage(image)">
                      <li [ngClass]="{'mb-image-item': true, 'active': image == currentImage }">
                        <a href="javascript:void(0)"><img [src]="image ? image : '../../assets/images/no_image_available.jpeg'" alt="image" /></a>
                      </li>
                  </ul>
                  <div class="swiper-pagination"></div>
                </div>
              </div>
              <!-- <div class="swiper-scrollbar"></div> -->
                <div class="slide-up swiper-button-prev" *ngIf="imageId.length > 3"><mat-icon>keyboard_arrow_up</mat-icon></div>
                <div class="slide-down swiper-button-next" *ngIf="imageId.length > 3"><mat-icon>keyboard_arrow_down</mat-icon></div>
            </div>
            <div class="mb-image-wrapper">
              <div ngxViewer [viewerOptions]="viewerOptions">
                <img id="mb-image-current" [src]="currentImage ? currentImage : '../../assets/images/no_image_available.jpeg'" alt="image" />
              </div>
            </div>
          </div>
          <div class="card-details product-details imageCard">
              <h2 class="product-details-title h2-line-clamp-5" [title]="summaryCard[retrieveDataByCardProperty('prop1')]">
                {{summaryCard[retrieveDataByCardProperty('prop1')]}}
              </h2>
              <p class="cardTitle line-clamp-1" [title]="summaryCard[retrieveDataByCardProperty('prop2')]">
                {{summaryCard[retrieveDataByCardProperty('prop2')]}}
              </p>
              <!-- <p class="cardTitle product-details-desc" [title]="summaryCard[retrieveDataByCardProperty('prop4')]">
                {{summaryCard[retrieveDataByCardProperty('prop4')]}}
              </p> -->
              <div class="cardBodyCopy">
                <a href="javascript:void(0)" [ngClass]="{'img-favourite': true, 'mb-highlight' : getBoolean(summaryCard[retrieveDataByCardProperty('id1')]) }"
                (click)="actionOnCardWithoutParam(summaryCard[retrieveDataByCardProperty('ID')], summaryCard[retrieveDataByCardProperty('button2')])"></a>
                <span style="float:left;">Favourite</span>
                <div class="clearfix"></div>
              </div>
              <p class="priceTitle" style="font-size: 24px;padding: 10px 0;">
                {{summaryCard[retrieveDataByCardProperty('prop3')]}}
              </p>
              <div class="form-group" style="display: flex; align-items: center;">
                <p style="font-size: 14px;margin-right: 15px;">Quantity</p>
                <div class="qty-container">
                  <div class="qty-icon" (click)="qtyInput.stepDown();$event.stopPropagation();$event.preventDefault()"><mat-icon>remove</mat-icon></div>
                  <input #qtyInput type="number" class="card-image-qty qty-min" min="1" value="1" (keyup)="keyupNumber(qtyInput, 100)">
                  <div class="qty-icon" (click)="qtyInput.stepUp();$event.stopPropagation();$event.preventDefault()"><mat-icon>add</mat-icon></div>
                </div>
              </div>
              <input type="button" class="btn btn-primary btn-add-to-cart" value="Add to Cart" 
              (click)="actionOnCard(qtyInput.value, summaryCard[retrieveDataByCardProperty('ID')], summaryCard[retrieveDataByCardProperty('button1')], summaryCard[retrieveDataByCardProperty('data')])"/>

              <p class="subtitle line-clamp-1" *ngIf="summaryCard[retrieveDataByCardProperty('prop5')]">Last ordered on {{ summaryCard[retrieveDataByCardProperty('prop5')] | date:'dd MMM yyyy' }}</p>
              <p class="subtitle line-clamp-1" *ngIf="!summaryCard[retrieveDataByCardProperty('prop5')]">No one has ordered this item</p>
          </div>
        </ng-container>
      </div>
      <div *ngIf="summaryLayout == 'HIERARCHY'" style="padding:8px;">
        <app-hierarchy-view [setTreeControl]="treeControl" [treeDataSource]="treeDataSource" [hasChildren]="hasChildren" (selectTree)="selectTree($event)" 
        [selectItem]="selectedItemId" (searchChanged)="searchHierarchy($event)" [hasSearch]="false" [setVirtualScroll]="false" [fromSummary]="true"></app-hierarchy-view>
      </div>
      <div *ngIf="summaryLayout == 'HIERARCHYVIEW'" style="padding:8px;">
        <app-hierarchy-view [setTreeControl]="treeControl" [treeDataSource]="treeDataSource" [hasChildren]="hasChildren" (selectTree)="selectTree($event)" 
        [selectItem]="selectedItemId" [viewMode]="true" (searchChanged)="searchHierarchy($event)" [hasSearch]="false" [setVirtualScroll]="false" [fromSummary]="true"></app-hierarchy-view>
      </div>
      <div *ngIf="summaryLayout == 'SUMMARYSUPPLIER'">
        <ng-container *ngFor="let summaryCard of summaryData; let i=index">
          <div class="flex-container">
            <div class="flex-item-1">
              <ng-container *ngIf="summaryCard[retrieveDataByCardProperty('ID')]; else noImage">
                <img *ngIf="isImageLoad" class="img-loading" src="../../assets/images/lazyload.gif">
                <img *ngIf="!isImageLoad" [class.no-img]="!getFirstImage(summaryCard[retrieveDataByCardProperty('ID')])"
                [src]="getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) ? getFirstImage(summaryCard[retrieveDataByCardProperty('ID')]) : '../../assets/images/no_image_available.jpeg'" 
                class="img" alt="image" />
              </ng-container>
              <ng-template #noImage>
                  <img src="../../assets/images/no_image_available.jpeg" alt="image" />
              </ng-template>
            </div>
            <div class="sub-flex-container">
              <div class="sub-flex-item-1">
                <rating class="rating" [(ngModel)]="rate" [max]="3" [readonly]="true"></rating>
                <span style="font-size: 12px;margin-left: 5px;position: relative;top: 0px;font-weight: 600;color: #555;">Trusted</span>
                <!-- <span id="invited" *ngIf="summaryCard[retrieveDataByCardProperty('prop13')]">
                  <div [ngClass]="{'circle-loader': true, 'load-complete': true}" style="position: relative;top: 8px;margin-right: 5px;">
                    <div class="checkmark-1 draw" [ngStyle]="{'display': 'block' }"></div>
                  </div>
                  Invited
                </span> -->
                <p class="card-supplier-title">{{summaryCard[retrieveDataByCardProperty('prop1')]}}<span>{{summaryCard[retrieveDataByCardProperty('prop2')]}}</span></p>
              </div>
              <div class="sub-flex-item-2">
                <div class="container">
                  <div class="row">
                    <div class="col-sm-4 summary-prop">
                      <b>Year of establishment</b>
                    </div>
                    <div class="col-sm-8 summary-prop">
                      <p>{{summaryCard[retrieveDataByCardProperty('prop3')]}}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4 summary-prop">
                      <b>Type of Company</b>
                    </div>
                    <div class="col-sm-8 summary-prop">
                      <p>{{summaryCard[retrieveDataByCardProperty('prop4')]}}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4 summary-prop">
                      <b>Employees</b>
                    </div>
                    <div class="col-sm-8 summary-prop">
                      <p>{{summaryCard[retrieveDataByCardProperty('prop5')]}}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4 summary-prop">
                      <b>Website</b>
                    </div>
                    <div class="col-sm-8 summary-prop">
                      <p>{{summaryCard[retrieveDataByCardProperty('prop6')]}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sub-flex-item-3">
                <div class="row">
                  <div class="col-sm-4 summary-prop">
                    <b>Annual Turnover</b>
                  </div>
                  <div class="col-sm-8 summary-prop">
                    <p>{{summaryCard[retrieveDataByCardProperty('prop7')]}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4 summary-prop">
                    <b>Type of Vendor</b>
                  </div>
                  <div class="col-sm-8 summary-prop">
                    <p>{{summaryCard[retrieveDataByCardProperty('prop8')]}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4 summary-prop">
                    <b>Category</b>
                  </div>
                  <div class="col-sm-8 summary-prop">
                    <p *ngIf="summaryCard[retrieveDataByCardProperty('prop9')]">
                      <app-read-more [text]="summaryCard[retrieveDataByCardProperty('prop9')]" [maxLength]="300" [textAlign]="'left'"></app-read-more>
                    </p>
                  </div>
                </div>
              </div>
              <div  class="sub-flex-item-4">
                <p *ngIf="summaryCard[retrieveDataByCardProperty('prop13')]" style="font-size: 13px;margin-top: 5px;color: var(--primary);">{{summaryCard[retrieveDataByCardProperty('prop13')]}}</p>
              </div>
            </div>
            <div class="flex-item-4">
              <div class="logo-container">
                <a *ngIf="summaryCard[retrieveDataByCardProperty('prop10')]" [href]="getLink(summaryCard[retrieveDataByCardProperty('prop10')])" target="_blank"><img src="../../assets/images/fb-ic.png" title="Facebook"></a>
                <a *ngIf="summaryCard[retrieveDataByCardProperty('prop11')]" [href]="getLink(summaryCard[retrieveDataByCardProperty('prop11')])" target="_blank"><img src="../../assets/images/linkedin-ic.png" title="LinkedIn"></a>
                <a *ngIf="summaryCard[retrieveDataByCardProperty('prop12')]" [href]="getLink(summaryCard[retrieveDataByCardProperty('prop12')])" target="_blank"><img src="../../assets/images/twitter-ic.png" title="Twitter"></a>
              </div>
            </div>
            <div class="flex-item-5">
              <div class="btn-case">
                <button class="btn btn-primary invite-btn mr-1" *ngIf="summaryCard[retrieveDataByCardProperty('button1')]"
                (click)="actionOnCardWithoutParam(summaryCard[retrieveDataByCardProperty('ID')], summaryCard[retrieveDataByCardProperty('button1')])">INVITE</button>
                <button class="btn btn-primary view-btn" *ngIf="summaryCard[retrieveDataByCardProperty('button2')]"
                (click)="actionOnCardWithoutParam(summaryCard[retrieveDataByCardProperty('ID')], summaryCard[retrieveDataByCardProperty('button2')])">VIEW</button>
              </div>
            </div>
          </div>
        </ng-container>
        <div *ngIf="summary.AvailablePages > summary.CurrentPage" style="display: flex;justify-content: center;padding:0;height: 70px;">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      </div>

    </ng-container>
    <ng-template #summaryNoData>
      <ng-container  *ngIf="summaryLayout != 'TABLE' && summaryLayout != 'TABLEADVANCED'">
        <div *ngIf="summaryLayout== 'CHATCARD'; else default" class="chat-card-container">
          <!-- new layout chat card -->
          <div *ngIf="!isPreview; else default" class="chat-flex-group">
            <input #textbox type="text"
            [ngClass]="{'form-control': true}"
            placeholder="Add a comment...">
            <button class="btn btn-primary chat-btn" (click)="addNewRemarkForDocument(textbox)">
              Add
            </button>
          </div>
        </div>
        <ng-template #default>
          <p *ngIf="documentName" class="text-center not-found"><i>No <span>{{documentName}}</span> found</i></p>
          <p *ngIf="!documentName" class="text-center not-found"><i>No record found here</i></p>
        </ng-template>
      </ng-container>
    </ng-template>

    <!-- ADVANCED TABLE -->
    
    <ng-container *ngIf="summaryLayout == 'TABLEADVANCED'">
      <app-advanced-table [componentId]="componentId" 
      [setColumns]="visibleColumns" 
      [setSummaryData]="summaryData" 
      [setSummary]="summary" 
      (exportSummary)="summaryFunction(actions[0])" 
      (exportCurrentView)="summaryFunction(actions[0], $event)"
      [isPopup]="isSummaryPopup"></app-advanced-table>
    </ng-container>

    <!-- TABLE -->
    <div *ngIf="summaryLayout == 'TABLE'">
      <div class="workflow-loader-ct" *ngIf="isPerformWorkflow">
        <div class="workflow-loader">
          <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
        </div>
      </div>
      <ng-container *ngIf="visibleColumns">
      <ng-container *ngIf="visibleColumns[0]">
        <ng-container *ngIf="visibleColumns[0].ViewColumnType == 'SUBDETAIL'; else table">
          <ng-container *ngIf="tableHasData; else summaryTableNoData">
            <ng-container *ngFor="let row of summaryData;">
              <app-detail [setComponentId]='subDetailId' [isSubDetail]="true"></app-detail>
            </ng-container>
          </ng-container>
          <ng-template #summaryTableNoData>
            <p class="text-center not-found" *ngIf="documentName; else noName"><i>No <span>{{documentName}}</span> found</i></p>
            <ng-template #noName>
              <p class="text-center not-found"><i>No record found</i></p>
            </ng-template>
          </ng-template>
        </ng-container>
      </ng-container>
      </ng-container>
      <ng-template #table>
        <div *ngIf="isChartTable; else defaultTable" style="width: 50%;margin: 0 auto;">
          <!-- <div style="display: flex;justify-content: space-between;">
            <div style="font-size: 11px;position: relative;left: -50px;">{{summaryData[0][visibleColumns[0].PropertyName]}}</div>
            <div style="font-size: 11px;position: relative;right: -50px;">{{summaryData[summaryData.length - 1][visibleColumns[0].PropertyName]}}</div>
          </div> -->

          <table [id]="summary.SummaryClass" style="display: none;" (ngInit)="onInitChartTable()" [isLast]='true'>
            <thead>
              <tr>
                <ng-container *ngFor="let column of visibleColumns">
                  <th *ngIf="column.IsID; else col"></th>
                  <ng-template #col>
                    <th>{{column.PropertyDisplay}}</th>
                  </ng-template>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of summaryData">
                <ng-container *ngFor="let column of visibleColumns;let first=first">
                  <th *ngIf="first">{{row[column.PropertyName]}}</th>
                  <td *ngIf="!first">{{row[column.PropertyName]}}</td>
                </ng-container>
              </tr>
            </tbody>
          </table>
          
          <!-- <div class="playback-container">
            <mat-slider [min]="'1'" [max]="summaryData.length" [step]="'1'" [value]="summaryData.length" style="width: 100%;"></mat-slider>
          </div> -->
        </div>
        <ng-template #defaultTable>
          <div #tableContainer *ngIf="summaryData.length > 0 && displaySummary" 
            [ngStyle]="{'overflow': 'auto', 'max-height': isFromExpandSummary ? '72vh' : summary.ColumnHasSearch ? '410px' : '380px'}"
            (scroll)="onMatTableScroll($event)">
            <table mat-table class="table" [dataSource]="summaryData" [multiTemplateDataRows]="true" matSort matSortDisableClear="true" [id]="summary.SummaryClass" 
            [matSortActive]="activeSort" [matSortDirection]="activeSortDirection" (ngInit)="onTableInit()" [isLast]='true'>

              <!-- Checkbox Column -->
              <ng-container *ngIf="summary.ShowCheckmark && visibleColumnNames.indexOf('#RowNumber') > -1" matColumnDef="#RowNumber">
                <th mat-header-cell *matHeaderCellDef style="width: 40px;text-align: center;">
                  <div class="table-header-content" [class.center]="!summary.ColumnHasSearch">
                    <span [class.header-content-label]="summary.ColumnHasSearch"></span>
                    <mat-checkbox (change)="$event ? selectAll($event) : null" [checked]="isSelectAll" [ngStyle]="{'margin-bottom': summary.ColumnHasSearch ? '5px' : '0px'}"
                    [indeterminate]="markList.length > 0 && !isSelectAll"></mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let row" style="width: 40px;text-align: center;">
                  <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? checkmark($event, row) : null"
                  [checked]="markList.indexOf(row[idColumn]) > -1"></mat-checkbox>
                </td>
              </ng-container>

              <!-- all visible columns -->
              <ng-container *ngFor="let column of visibleColumns;trackBy: colTrackBy" matColumnDef="{{column.PropertyName}}">
                <th mat-header-cell *matHeaderCellDef [ngStyle]="{'width': 'calc(100% * '+column.WidthWeight+' / '+ totalRatioWidth+')'}">
                  <ng-container *ngIf="!summary.ColumnHasSearch">
                    <span class="header-label" (click)="sortBySummaryColumn(column.PropertyName)" mat-sort-header [start]="'asc'" [innerHTML]="column.PropertyDisplay"></span>
                    <span *ngIf="column.CellsSelected > 0" class="cells-count">{{column.CellsSelected}}</span>
                  </ng-container>
                  <div *ngIf="summary.ColumnHasSearch" class="table-header-content">
                    <span class="header-content-label" (click)="sortBySummaryColumn(column.PropertyName)" mat-sort-header [start]="'asc'" [innerHTML]="column.PropertyDisplay"></span>
                    <span *ngIf="column.CellsSelected > 0" class="cells-count">{{column.CellsSelected}}</span>
                    <div *ngIf="column.ViewColumnType.startsWith('DISPLAY'); else default" class="filter-column" style="margin-top: auto;">
                      <div *ngIf="column.AdditionalParameter == 'lookup'; else nosearch">
                        <ng-select #select [items]="column.FilterValueSelection"
                          id="{{column.PropertyName}}"
                          class="summary-dropdown summary-filter-dropdown"
                          [class.changed]="column.IsFilterChanged"
                          (blur)="filterByColumn(column.ColumnFilterArray, column.PropertyName, true)" 
                          [clearable]="false" 
                          (click)="getFilterDropdownList(column.PropertyName); select.focus()"
                          (change)="onFilterChanged(column.PropertyName)"
                          (open)="openCombobox(true)"
                          (close)="closeCombobox(true);column.IsFilterChanged = false"
                          (clear)="clear(column.PropertyName, select)"
                          appendTo="body"
                          [searchable]="true"
                          [closeOnSelect]="false"
                          [multiple]="true"
                          bindLabel="SelectionDisplay"
                          bindValue="SelectionValue"
                          placeholder="Select {{column.PropertyDisplay.toLowerCase()}}"
                          [(ngModel)]="column.ColumnFilterArray"
                          [name]="column.PropertyName">
                          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of (items ? items.slice(0,1): [])">
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                <span class="ng-value-label">{{item.SelectionDisplay}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                      <ng-template #nosearch>
                        <ng-container *ngIf="column.AdditionalParameter == 'NoColumnSearch'; else search">
                          <div style="min-height: 28px;margin-top: auto;"></div>
                        </ng-container>
                      </ng-template>
                      <ng-template #search>
                        <input #searchColumn type="text"
                        [autocomplete]="off"
                        [placeholder]="'Search ' + column.PropertyDisplay.toLowerCase()" 
                        class="search-column" 
                        (keyup.enter)="filterByColumn(searchColumn.value, column.PropertyName)" 
                        [value]="column.ColumnFilterString"/>
                        <img class="img-search" src="../../assets/images/search.png" (click)="filterByColumn(searchColumn.value, column.PropertyName)">
                      </ng-template>
                    </div>
                    <ng-template #default>
                      <div style="min-height: 28px;margin-top: auto;"></div>
                    </ng-template>
                  </div>
                </th>
                <td mat-cell *matCellDef="let row;let i=dataIndex" [class]="column.PropertyName" [class.align-right]="column.AdditionalParameter == 'ALIGNRIGHT'" 
                [ngStyle]="{'width': 'calc(100% * '+column.WidthWeight+' / '+ totalRatioWidth+')'}" 
                [class.selected]="row['selected'] ? row['selected'].indexOf(column.PropertyName) > -1 ? true : false : false"
                (click)="selectCell(column, row);">
                  <!-- DISPLAY -->
                  <ng-container *ngIf="column.ViewColumnType == 'DISPLAY'">
                    <p *ngIf="row[column.PropertyName]" class="table-text" [title]="row[column.PropertyName]">
                      {{ row[column.PropertyName].length > 50 ? row[column.PropertyName].substr(0, 50) + '...' : row[column.PropertyName] }}
                    </p> 
                  </ng-container>
                  <!-- DISPLAYFULL -->
                  <ng-container *ngIf="column.ViewColumnType == 'DISPLAYFULL'">
                    <p class="table-text" [title]="row[column.PropertyName]">
                      {{ row[column.PropertyName] }}
                    </p>
                  </ng-container>
                  <!-- DISPLAYHTML -->
                  <ng-container *ngIf="column.ViewColumnType == 'DISPLAYHTML'">
                    <span class="display-webkit" [innerHTML]="row[column.PropertyName]"></span>
                  </ng-container>
                  <!-- DISPLAYNUMBERFORMAT -->
                  <ng-container *ngIf="column.ViewColumnType == 'DISPLAYNUMBERFORMAT'">
                    <span>{{ row[column.PropertyName] }}</span>
                  </ng-container>
                  <!-- EDITABLETEXT -->
                  <div *ngIf="column.ViewColumnType == 'EDITABLETEXT'" class="editable-text-container">
                    <input #editabletext type="text" [(ngModel)]="row[column.PropertyName]" [id]="summary.SummaryClass + '_' + i + '_' + column.PropertyName"
                      [name]="row[column.PropertyName]"
                      [ngClass]="{'editable-text': true}" 
                      (input)="onChangeData(row, column, editabletext.value)"/>
                  </div>
                  <!-- EDITABLEDATE -->
                  <div *ngIf="column.ViewColumnType == 'EDITABLEDATE'" class="date-input-container" style="display: flex">
                    <div class='input-group'>
                      <input #editabledate class="form-control date-input" [matDatepicker]="i"
                        [(ngModel)]="row[column.PropertyName]"
                        placeholder="Select Date"
                        [name]="row[column.PropertyName]"
                        (dateChange)="onChangeData(row, column, editabledate.value)">
                        <mat-datepicker #i></mat-datepicker>
                      <div class="input-group-append date-group" (click)="i.open()">
                        <span class="input-group-text" style="cursor: pointer;"><i class="fa fa-calendar"></i></span>
                      </div>
                    </div>
                  </div>
                  <!-- CHECKBOX -->
                  <div *ngIf="column.ViewColumnType == 'CHECKBOX'" style="width: 100%;">
                    <mat-radio-group 
                      [id]="summary.SummaryClass + '_' + i + '_' + column.PropertyName"
                      [(ngModel)]="row[column.PropertyName]"
                      [name]="column.PropertyName + i"> 
                      <div *ngFor="let info of column.AdditionalInfo" class="mat-checkbox-container">
                        <mat-checkbox
                        [attr.name]="column.PropertyName + '_' + i"
                        (change)="onChangeData(row, column, $event, info.SelectionValue)" 
                        [value]="info.SelectionValue" 
                        [checked]="row[column.PropertyName].indexOf(info.SelectionValue) > -1">{{ info.SelectionDisplay }}</mat-checkbox>
                      </div>
                    </mat-radio-group>
                  </div>
                  <!-- COMBOBOX -->
                  <div *ngIf="column.ViewColumnType == 'COMBOBOX'" style="padding: 0 5px;width: 100%;">
                    <ng-select [items]="column.AdditionalInfo"
                      [id]="summary.SummaryClass + '_' + i + '_' + column.PropertyName"
                      [ngClass]="{'summary-dropdown': true }"
                      (change)="onChangeData(row, column, row[column.PropertyName])" 
                      [clearable]="false" 
                      (open)="openCombobox(true)"
                      (close)="closeCombobox(true)"
                      appendTo="body"
                      [title]="row[column.PropertyName]"
                      [searchable]="true"
                      bindLabel="SelectionDisplay"
                      bindValue="SelectionValue"
                      placeholder="Please select"
                      [(ngModel)]="row[column.PropertyName]"
                      [name]="column.PropertyName">
                    </ng-select>
                  </div>
                  <!-- MULTICOMBOBOX -->
                  <div *ngIf="column.ViewColumnType == 'MULTICOMBOBOX'" style="padding: 0 5px;width: 100%;">
                    <ng-select [items]="column.AdditionalInfo"
                      [id]="summary.SummaryClass + '_' + i + '_' + column.PropertyName"
                      [ngClass]="{'summary-multi-dropdown': true }"
                      (change)="onChangeData(row, column, row[column.PropertyName])" 
                      [clearable]="false"
                      (open)="openCombobox()"
                      (close)="closeCombobox()"
                      [multiple] = "true"
                      [title]="row[column.PropertyName]"
                      [searchable]="true"
                      appendTo="{{ isSummaryPopup ? 'body' : null }}"
                      [closeOnSelect]="false"
                      bindLabel="SelectionDisplay"
                      bindValue="SelectionValue"
                      placeholder="Please select"
                      [(ngModel)]="row[column.PropertyName]"
                      [name]="column.PropertyName"
                      [clearSearchOnAdd]="true">
                      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value" *ngFor="let item of (items ? items.slice(0,5): [])">
                          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                          <span class="ng-value-label">{{item.SelectionDisplay}}</span>
                        </div>
                        <div class="ng-value" *ngIf="items.length > 5">
                          <span class="ng-value-label">{{items.length - 5}} more...</span>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <!-- FILE -->
                  <ng-container *ngIf="column.ViewColumnType == 'FILE'">
                    <ng-container *ngIf="row[column.PropertyName]">
                      <div class="file file-download" (click)="downloadFileCol(row, column)"
                        [title]="row[column.PropertyName].split('|')[1]">
                        {{ row[column.PropertyName].split('|')[1] }}
                      </div>
                    </ng-container>
                  </ng-container>
                  <!-- FILEREPORT -->
                  <ng-container *ngIf="column.ViewColumnType == 'FILEREPORT'">
                    <ng-container *ngIf="row[column.PropertyName]">
                      <a class="file" (click)="getFileReport(row, column);" href="javascript:void(0)"
                      [title]="row[column.PropertyName].split('|')[1]">{{ row[column.PropertyName].split('|')[1] }}</a>
                    </ng-container>
                  </ng-container>
                  <!-- FILEUPLOAD -->
                  <ng-container *ngIf="column.ViewColumnType == 'FILEUPLOAD'">
                    <div style="height: 26px; display: flex;align-items: center;">
                      <div *ngIf="row['isUploading']" style="display: inline-flex; padding: 0 0.5rem">
                        <mat-spinner diameter="18"></mat-spinner>
                        <span>Uploading...</span>
                      </div>
                      <div *ngIf="!isPreview" [ngClass]="{'browse-button': true, 'hide': row['isUploading'], 'disabled': row[column.PropertyName] == '0' || row[column.PropertyName] == '1'}" style="float:left">
                        <label for="{{row[idColumn]}}">
                          Upload
                        </label>
                      </div>
                      <ng-container *ngIf="!row['isUploading']">
                        <!-- <p>{{row[column.PropertyName]}}</p> -->
                        <ng-container *ngFor="let file of getFileSummary(row, column)">
                          <a *ngIf="row[column.PropertyName] !== '1'" class="file" [href]="file.AttachmentUrl" [title]="file.AttachmentName" download="{{ file.AttachmentName }}">{{ file.AttachmentName }}</a>
                        </ng-container>
                      </ng-container>
                      <input #file type="file" (change)="onFileChange($event, row, column)" id="{{row[idColumn]}}" class="fileAttachment" accept="{{acceptFormatString}}" hidden/>
                    </div>
                  </ng-container>
                  <!-- IMAGE -->
                  <div *ngIf="column.ViewColumnType == 'IMAGE'" class="tr-img-container">
                    <ng-container *ngIf="row[idColumn]; else noImage">
                      <img *ngIf="isImageLoad" class="img-loading" src="../../assets/images/lazyload.gif">
                      <ng-container *ngIf="!isImageLoad">
                        <ng-container *ngIf="getFirstImage(row[idColumn]); else defaultImage">
                          <img [src]="getFirstImage(row[idColumn])" class="img" alt="image"/>
                        </ng-container>
    
                        <ng-template #defaultImage>
                          <img [src]="'../../assets/images/no_image_available.jpeg'" 
                          class="img" alt="image" />
                        </ng-template>
                      </ng-container>
                      
                    </ng-container>
                    <ng-template #noImage>
                        <img src="../../assets/images/no_image_available.jpeg" alt="image" />
                    </ng-template>
                  </div>
                  <!-- INDICATOR -->
                  <ng-container *ngIf="column.ViewColumnType == 'INDICATOR'">
                    <ng-container *ngIf="column.AdditionalParameter">
                      <div *ngFor="let parameter of column.AdditionalParameter.split('|')" class="indicator-container">
                        <span class="indicator">
                          <ng-container [ngSwitch]="parameter.split(separator)[0].replace('{', '').replace('}', '')">
                            <mat-icon *ngSwitchCase = "'Edit'" (click)="openDetail(row[idColumn])" title="Edit">edit</mat-icon>
                            <mat-icon *ngSwitchCase = "'View'" (click)="openDetail(row[idColumn])" title="View">visibility</mat-icon>
                            <mat-icon *ngSwitchCase = "'Remove'" (click)="performRowAction(row[idColumn], parameter)" title="Remove">delete</mat-icon>
                            <ng-container *ngSwitchCase="'Pending'">
                              <ng-container [ngSwitch]="row[column.PropertyName]">
                                <img *ngSwitchCase="'GOOD'" width="15" height="15" src="../../assets/images/check.png">
                                <img *ngSwitchCase="'BAD'" width="15" height="15" src="../../assets/images/cross.png">
                                <img *ngSwitchCase="'NEUTRAL'" width="15" height="15" src="">
                                <img *ngSwitchDefault width="15" height="15" src="../../assets/images/pending.png">
                              </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Expand'">
                              <div (click)="expandSummary(row, parameter);expandedElement = expandedElement === row ? null : row" 
                              class="expand-ic" matTooltip="Drilldown" [class.expanding]="row['isExpanding']">
                                <fa *ngIf="!row['summaryBreakdownExpand']" name="chevron-down" class="chevron-down"></fa>
                                <fa *ngIf="row['summaryBreakdownExpand']" name="chevron-up" class="chevron-up"></fa>
                              </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Budget'">
                              <img width="14" height="14" [src]="row[column.PropertyName] ? '../../assets/images/money-green.png'
                              : '../../assets/images/money-red.png'" matTooltip="{{row[column.PropertyName] ? 'Within Budget' : 'Out of budget'}}">
                            </ng-container>
                            <ng-container *ngSwitchCase="'Updating'">
                              <ng-container *ngIf="row[column.PropertyName] == 1; else updated">
                                <img width="15" height="15" src='../../assets/images/lazyload_small.gif' matTooltip="Updating">
                              </ng-container>
                              <ng-template #updated>
                                <span></span>
                              </ng-template>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Status'">
                              <ng-container [ngSwitch]="row[column.PropertyName]">
                                <div *ngSwitchCase="'1'" class="new-ic">NEW</div>
                                <div *ngSwitchCase="'2'" class="deleted-ic">DEL</div>
                                <span *ngSwitchDefault></span>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'New'">
                              <div *ngIf="row[column.PropertyName] == 1; else empty" class="new-ic">NEW</div>
                              <ng-template #empty>
                                <span></span>
                              </ng-template>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Deleted'">
                              <div *ngIf="row[column.PropertyName] == 1; else empty" class="deleted-ic">DEL</div>
                              <ng-template #empty>
                                <span></span>
                              </ng-template>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Mandatory'">
                              <div [class.mandatory]="row[column.PropertyName] == 0"></div>
                            </ng-container>
                            <button *ngSwitchDefault class="btn btn-primary btn-indicator" (click)="performAction(row[idColumn], parameter)">
                              {{ parameter.split(':')[0].replace('{', '').replace('}', '') }}
                            </button>
                          </ng-container>
                        </span>
                        <div class="clearfix" *ngIf="parameter.split(':')[0].replace('{', '').replace('}', '') == 'Budget'"></div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <!-- DEFAULT -->
                  <ng-container *ngIf="!column.ViewColumnType">
                    <span class="display-webkit" [title]="row[column.PropertyName]">{{ row[column.PropertyName] }}</span>
                  </ng-container>
                </td>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let row" [attr.colspan]="visibleColumnNames.length">
                  <div class="expanded-detail"
                    [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'">
                    <app-sub-summary 
                      [componentIdSet]="row['summaryBreakdown']" 
                      (subSelectedId)="emitSelectedItem($event)"></app-sub-summary>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="visibleColumnNames; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: visibleColumnNames;let i = dataIndex" 
              id="{{summary.SummaryClass}}_{{i}}"
              [ngStyle]="{'background-color': markList.indexOf(row[idColumn]) > -1 ? 'var(--secondary)' : '#fff'}"
              [class.example-expanded-row]="expandedElement === row"></tr>
              <ng-container *ngIf="isBreakdownSummary">
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-row"></tr>
              </ng-container>

            </table>
          </div>
          <div *ngIf="isFetching" class="loader-fetch" style="height: 5px;"></div>

          <div *ngIf="summaryData.length === 0">
            <table mat-table [dataSource]="summaryData" class="table" [id]="summary.SummaryClass">
              <ng-container *ngIf="summary.ShowCheckmark && visibleColumnNames.indexOf('#RowNumber') > -1" matColumnDef="#RowNumber">
                <th mat-header-cell *matHeaderCellDef style="width: 40px;"></th>
                <td mat-cell *matCellDef="let row" style="width: 40px;"></td>
              </ng-container>

              <ng-container *ngFor="let column of visibleColumns" matColumnDef="{{column.PropertyName}}">
                <th mat-header-cell *matHeaderCellDef [ngStyle]="{'width': 'calc(100% * '+column.WidthWeight+' / '+ totalRatioWidth+')'}">
                  <ng-container *ngIf="!summary.ColumnHasSearch">
                    <span class="header-label" [innerHTML]="column.PropertyDisplay"></span>
                  </ng-container>
                  <div *ngIf="summary.ColumnHasSearch" class="table-header-content">
                    <span class="header-content-label" [innerHTML]="column.PropertyDisplay"></span>
                    <div *ngIf="column.ViewColumnType.startsWith('DISPLAY'); else default" class="filter-column" style="margin-top: auto;">
                      <div *ngIf="column.AdditionalParameter == 'lookup'; else nosearch">
                        <ng-select #select [items]="column.FilterValueSelection"
                          id="{{column.PropertyName}}"
                          class="summary-dropdown summary-filter-dropdown"
                          [class.changed]="column.IsFilterChanged"
                          (blur)="filterByColumn(column.ColumnFilterArray, column.PropertyName, true)" 
                          [clearable]="false" 
                          (click)="getFilterDropdownList(column.PropertyName); select.focus()"
                          (change)="onFilterChanged(column.PropertyName)"
                          (open)="openCombobox(true)"
                          (close)="closeCombobox(true);column.IsFilterChanged = false"
                          (clear)="clear(column.PropertyName, select)"
                          appendTo="body"
                          [searchable]="true"
                          [closeOnSelect]="false"
                          [multiple]="true"
                          bindLabel="SelectionDisplay"
                          bindValue="SelectionValue"
                          placeholder="Select {{column.PropertyDisplay.toLowerCase()}}"
                          [(ngModel)]="column.ColumnFilterArray"
                          [name]="column.PropertyName">
                          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of (items ? items.slice(0,1): [])">
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                <span class="ng-value-label">{{item.SelectionDisplay}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                      <ng-template #nosearch>
                        <ng-container *ngIf="column.AdditionalParameter == 'NoColumnSearch'; else search">
                          <div style="min-height: 28px;margin-top: auto;"></div>
                        </ng-container>
                      </ng-template>
                      <ng-template #search>
                        <input #searchColumn type="text"
                        [autocomplete]="off"
                        [placeholder]="'Search ' + column.PropertyDisplay.toLowerCase()" 
                        class="search-column" 
                        (keyup.enter)="filterByColumn(searchColumn.value, column.PropertyName)" 
                        [value]="column.ColumnFilterString"/>
                        <img class="img-search" src="../../assets/images/search.png" (click)="filterByColumn(searchColumn.value, column.PropertyName)">
                      </ng-template>
                    </div>
                    <ng-template #default>
                      <div style="min-height: 28px;margin-top: auto;"></div>
                    </ng-template>
                  </div>
                </th>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="visibleColumnNames; sticky: true"></tr>
            </table>
            <div class="text-center not-found">No record found</div>
          </div>

          <div class="footer-table" *ngIf="summary.ShowCheckmark && tableHasData && summary.SelectionType == 'MULTI'">
            {{selectedRowCount}} selected / {{summary.TotalRows}} total
          </div>

        </ng-template>
        </ng-template>
      </div>
      <div *ngIf="summaryLayout == 'EDITABLECARD'">
          <!-- CARD Type 6 - Editable Card -->
        <div *ngFor="let summaryCard of summaryData" class="editable-card-container">
          <button type="button" class="close close-editable-card" aria-label="Close" (click)="performAction(summaryCard.DocumentInstanceId, parameter)" >
              <span aria-hidden="true">&times;</span>
          </button>
          <!-- <h1 class="card-image-editable-title">Product and Services</h1>  -->
          <div style="padding: 15px 0 0;">
            <div class="dex-1">
              <div class="uploader">
                <img *ngIf="getImageURL(summaryCard[retrieveDataByCardProperty('ID')]);else noImage" [src]="getImageURL(summaryCard[retrieveDataByCardProperty('ID')])" height="200">
                <ng-template #noImage>
                  <img src="../../assets/images/no_image_available.jpeg" />
                </ng-template>
                <input type="file" name="userprofile_picture" class="filePhoto" (change)="onSelectFile($event, summaryCard[retrieveDataByCardProperty('ID')])"/>
              </div>
              <p class="editable-card-img-desc">{{summaryCard[retrieveDataByCardProperty('lbl4')]}}<br/>{{summaryCard[retrieveDataByCardProperty('lbl5')]}}</p>
            </div>
            <div class="dex-2">
              <div class="form-group row">
                <label class="col-lg-4">{{summaryCard[retrieveDataByCardProperty('lbl1')]}}</label>
                <div class="col-lg-8">
                  <input class="form-control" type="text" [value]="summaryCard[retrieveDataByCardProperty('prop1')]" />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-lg-4">{{summaryCard[retrieveDataByCardProperty('lbl2')]}}</label>
                <div class="col-lg-8">
                  <textarea class="form-control custom-scrollbar" rows="8" style="resize:none;">{{summaryCard[retrieveDataByCardProperty('prop2')]}}</textarea>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-lg-4">{{summaryCard[retrieveDataByCardProperty('lbl3')]}}</label>
                <div class="col-lg-8">
                  <input name="dropdownValue" class="dropdown-detailcombobox" type="hidden">
                  <div style="float: left;">
                    <input class="form-control" type="text" [value]="summaryCard[retrieveDataByCardProperty('prop4')]"/>
                  </div>
                  <input name="dropdownValue" class="dropdown-detailcombobox" type="hidden">
                </div>
              </div>
            </div>   
          </div>  
        </div>
      </div>
      <!-- <div *ngIf="summaryLayout.startsWith('CARD') || summaryLayout == 'EDITABLECARD' || summaryLayout == 'SUMMARYSUPPLIER'" class="card-loading-container">
        <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
      </div> -->
  </div>
  <ng-container *ngIf="summary.FooterText">
    <p class="summary-header-text" [innerHTML]="summary.FooterText | safe_html"></p>
  </ng-container>
  <!-- <p  class="summary-header-text" [innerHTML]="summary.FooterText"></p> -->
</div>
<div *ngIf="errorMessage">
  <p class="error-text">{{errorMessage}}</p>
</div>
<ng-container *ngIf="summary && summaryLayout">
<ng-container *ngIf="summary.Actions && (summaryLayout.startsWith('CARD') || summaryLayout == 'EDITABLECARD' || summaryLayout == 'SUMMARYSUPPLIER') && summaryLayout != 'CARDINPUT'">
  <div *ngIf="summary.Actions.length > 0" style="float: left;margin-left: 0.5rem;margin-top: 0.5rem;">
    <ng-container *ngFor="let action of summary.Actions">
      <input type="button" *ngIf="!action.DisplayOnGroup && !action.IsHidden" value="{{ action.ActionDisplay }}" class="btn btn-primary mr-1 button-action btn-clear" (click)="performAction('', action.ActionCommand, action)" 
      [disabled]="action.IsDisabled"> 
    </ng-container>
  </div>
  <div class="clearfix"></div>
</ng-container>
</ng-container>
<context-menu #itemContextMenu>
  <ng-template *ngFor="let action of actions" contextMenuItem let-item (execute)="summaryFunction(action)">
    <ng-container *ngIf="action.ActionSequence != 0">
      {{ action.ActionDisplay }}
    </ng-container>
  </ng-template>
</context-menu>